<template>
    <div class="scheduler-table">
        <div class="columns hours_container">
            <div class="column hours_box" v-if="!noPredictions" v-for="(h, index) in hoursFilled" :key="index" :class="predGoal(h.scheduled, h.total_drivers)">
                <p><b>{{ h.sc_dt }}</b></p>
                <p>{{ h.scheduled }} / {{ h.total_drivers }}</p>
            </div>
        </div>
        <div class="nothing-scheduled" v-if="displayDrivers.length === 0">
            <h3>No Drivers Scheduled yet</h3>
            <p>Drag and drop drivers from to left to start scheduling</p>
        </div>
        <b-table :data="displayDrivers" class="table-block" sticky-header height="500px" v-else>
            <template slot-scope="props">
                <b-table-column field="text" label="Driver Name" sortable>
                    {{ props.row.text }}
                    <p class="is-small" v-if="props.row.isGhost"><i>Placeholder</i></p>
                </b-table-column>
                <b-table-column field="serviceType" label="Service Type" sortable>
                    <b-select v-model="props.row.serviceType" size="is-medium" v-if="props.row.all_tcd.length > 1 && !props.row.readonly" @input="inputChanges('serviceType', props.row)">
                        <option v-for="s in props.row.all_tcd" :value="s" :key="s">{{ s }}</option>
                    </b-select>
                    <p v-if="props.row.readonly || props.row.all_tcd.length <= 1">{{ props.row.serviceType }}</p>
<!--                    {{ props.row.serviceType }}-->
                </b-table-column>
                <b-table-column field="start_date" label="Start" sortable>
                    <b-timepicker v-model="props.row.start_date" @input="inputChanges('start_date', props.row)" hour-format="12" :incrementMinutes="15" inline v-if="!props.row.readonly"></b-timepicker>
                    <p v-else>{{ props.row.start_date | timeFilter }}</p>
                </b-table-column>
                <b-table-column field="end_date" label="End" sortable>
                    <b-timepicker v-model="props.row.end_date" @input="inputChanges('end_date', props.row)" hour-format="12" :incrementMinutes="15" inline v-if="!props.row.readonly"></b-timepicker>
                    <p v-else>{{ props.row.end_date | timeFilter }}</p>
                </b-table-column>
                <b-table-column field="duration" label="Duration" sortable>
                    {{ getDuration(props.row.start_date, props.row.end_date) }}
                </b-table-column>
                <b-table-column label="Remove">
                    <b-button type="is-danger" @click="removeDriver('deleted', props.row)" v-if="!props.row.readonly">Remove</b-button>
                </b-table-column>
                <b-table-column :class="setNotes(props.row).css" label="Notes">
                    <p v-if="!props.row.readonly">{{ setNotes(props.row).message }}</p>
                    <p v-else>These are overnight drivers from the day before.</p>
                </b-table-column>
            </template>
<!--            <b-table-column v-slot="props" label="Driver">-->
<!--                {{ props.row.text }}-->
<!--            </b-table-column>-->
<!--            <b-table-column v-slot="props" label="Start">-->
<!--                {{ props.row.start_date }}-->
<!--            </b-table-column>-->
<!--            <b-table-column v-slot="props" label="End">-->
<!--                {{ props.row.end_date }}-->
<!--            </b-table-column>-->

        </b-table>
    </div>
</template>

<script>
import moment from 'moment'
// Emitters needed
/*
* taskUpdate
* linkUpdate (maybe)
* taskSelected (maybe)
* goalStatus
* cleared
* droppedInfo
* */
export default {
    name: "ScheduleTable",
    props: ['data', 'predictedHours', 'date', 'code', 'editted', 'edit', 'hourlyType', 'clear', 'taskToDelete', 'tasks', 'noPredictions'],
    // props: ['data'],
    data() {

        return {

        }
    },

    methods: {
        inputChanges(type, driver) {
            // emit: logTaskUpdate
            // emit params: id, update type ('delete', etc...), driver/task
            if (type === 'deleted') {
                this.$emit('task-updated', driver.id, type, driver)
            } else {
                this.$emit('task-updated', driver.id, type, driver)
            }
           console.log('time changed for ', type)
        },
        removeDriver(type, driver) {
            let _t = this
            _t.$buefy.dialog.confirm({
                message: 'Are you sure you want to remove this driver from the schedule?',
                type: 'is-danger',
                confirmText: 'Yes, remove driver',
                cancelText: 'No, keep driver on schedule',
                onConfirm: () => {
                    _t.inputChanges(type, driver)
                }
            })
        },
        getDuration(start, end) {
            let difference = moment.duration(moment(end).diff(moment(start)))
            let duration = difference.asHours()
            if (duration <= 0) {
                duration += 24;
            }
            return duration
        },
        setNotes(driver) {
            if (driver.outOnPTO || driver.color == '#901900') {
                return {message: 'This driver is currently scheduled to be Out or Unavailable', css: 'is_driver_out'}
            }
            let start_h = parseInt(moment(driver.start_date).format('H'))
            let start_m = parseInt(moment(driver.start_date).format('mm'))
            let end_h = parseInt(moment(driver.end_date).format('H'))
            let end_m = parseInt(moment(driver.end_date).format('mm'))
            let available_start = driver.available_start
            let available_end = driver.available_end
            if (start_h < available_start.hour || end_h > available_end.hour || ((start_h === available_start.hour && start_m < available_start.minutes) || (end_h === available_end.hour && end_m > available_end.minutes))) {
                let curr_av_start = (available_start.hour > 12 ? available_start.hour - 12 : available_start.hour) + ':' + (available_start.minutes < 10 ? '0' + available_start.minutes : available_start.minutes) + (available_start.hour > 12 ? 'PM' : 'AM')
                let curr_av_end = (available_end.hour > 12 ? available_end.hour - 12 : available_end.hour) + ':' + (available_end.minutes < 10 ? '0' + available_end.minutes : available_end.minutes) + (available_end.hour > 12 ? 'PM' : 'AM')
                return {message: `This driver is currently is scheduled to be working outside of their availability. Current availability: ${curr_av_start} - ${curr_av_end}`, css: 'is_driver_out_of_range'}
            }
            return {message: '', css: ''}
        },
        predGoal(scheduled, need) {
            let diff = scheduled - need
            if (diff === 0) {
                return 'is-goal'
            } else if (diff === -1) {
                return 'need-one-more'
            } else if (diff > 0) {
                return 'over-goal'
            } else {
                return 'need-more'
            }
        }
    },
    computed: {
        displayDrivers() {
            let data = this.data
            if (this.code !== 'all') {
                let filter = this.code
                if (filter === 'battery_light_service') {
                    filter = ['Battery', 'Light Service']
                } else if (filter === 'tow_light_service') {
                    filter = ['Tow', 'Light Service']
                } else {
                    filter = [this.code]
                }
                data = data.filter(d => {
                    if (filter.includes(d.serviceType)) return d
                })
            }
            return data
        },
        hoursFilled() {
            let date = moment(this.date)
            let hoursFilled = {}
            console.log('getting hours filled')
            for (let i = 0; i < 33; i++) {
                if (i === 0) console.log('getting hours filled - inside for loop')
                let hour_calc = i
                if (i > 23) {
                    hour_calc -= 24
                    date = date.add(1, 'days')
                }
                date.set({hours: hour_calc, minute: 0, second: 0, millisecond: 0})
                let compare_date = date
                hoursFilled[compare_date.format('MM/DD/YYYY HH:mm')] = 0
                console.log('getting hours filled - hours filled', hoursFilled)
                this.displayDrivers.forEach(d => {
                    let start_h = moment(d.start_date)
                    let end_h = moment(d.end_date)
                    if (start_h <= compare_date && end_h >= compare_date) {
                        hoursFilled[compare_date.format('MM/DD/YYYY HH:mm')] += 1
                    }
                })
                if (i > 23) {
                    date = date.subtract(1, 'days')
                }
            }
            console.log(hoursFilled)
            console.log(this.predictedHours)
            let predHours = this.predictedHours.map(p => {
                let details = {...p}
                if (details['total_drivers'] < 0) {
                    details['total_drivers'] = 0
                }
                details['scheduled'] = hoursFilled[p.sc_dt]
                return details
            })
            return predHours
        }
    },
    watch: {
        data() {

        }
    },
    filters: {
        timeFilter(val) {
            return moment(val).format('h:mmA')
        },
        realDuration(val) {
            return val / 4;
        }
    }
}
</script>

<style scoped>
.scheduler-table {
    width: 100%;
}
.table-block {
    max-height: 600px;
    overflow: auto;
}
.is_driver_out {
    background: #901900;
    color: #fff;
}
.is_driver_out_of_range {
    background: #000;
    color: #fff;
}
.hours_container {
    width: 100%;
    overflow: auto;
}
.hours_box {
    padding: 3px;
    margin: 3px;
    border: solid thin #ddd;
    border-radius: 5px;
}
.is-goal {
    background: #1D8935;
    color: #fff;
}
.need-more {
    background: #F57773;
    color: #fff;
}
.need-one-more {
    background: #F5D273;
    color: #000;
}
.over-goal {
    background: #7657A7;
    color: #fff;
}
.nothing-scheduled {
    background: #eee;
    color: #000;
    width: 100%;
    height: 300px;
    border: dashed medium #333;
    vertical-align: center;
    position: relative;
    padding-top: 30px;
    border-radius: 5px;
}
.nothing-scheduled > h3 {
    color: #333;
    vertical-align: center;
}
</style>
